import React from 'react';
import { Testimonial } from '../types';

interface TestimonialCardProps {
  testimonial: Testimonial;
  index?: number;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({ testimonial, index }) => {
  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <span key={i} className="material-icons" data-star-index={i + 1} style={{ fontSize: '1.25rem' }}>
        {i < rating ? 'star' : 'star_border'}
      </span>
    ));
  };

  return (
    <div
      className="testimonial-card"
      data-cms-index={index}
    >
      <div
        className="testimonial-stars"
        data-cms-field="testimonials"
        data-cms-index={index}
        data-cms-item-field="rating"
        data-cms-field-type="rating"
        data-rating={testimonial.rating}
      >
        {renderStars(testimonial.rating)}
      </div>
      <p className="testimonial-text" data-cms-field="testimonials" data-cms-index={index} data-cms-item-field="text">{testimonial.text}</p>
      <p className="testimonial-author" data-cms-field="testimonials" data-cms-index={index} data-cms-item-field="author">{testimonial.author}</p>
      {testimonial.agentName && (
        <p className="testimonial-agent" data-cms-field="testimonials" data-cms-index={index} data-cms-item-field="agentName">Working with {testimonial.agentName}</p>
      )}
    </div>
  );
};

export default TestimonialCard;
